import { createBlobServiceAnonymous } from "azure-storage";
import { HOST_AZURE_STORAGE } from "../constants";
import { BusinessUnitConfig } from "../config/businessUnitConfig";
const defaultObjetiveConfig = require("../config/objetive-config.json");

const getBusinessConfig = async () => {
  const blobService = createBlobServiceAnonymous(
    process.env.VUE_APP_HOST_NAME_AZURE_STORAGE || HOST_AZURE_STORAGE
  );
  return new Promise((resolve, reject) => {
    blobService.getBlobToText("config", "businessUnitConfig.json", function(
      error,
      text
    ) {
      if (!error) {
        resolve(JSON.parse(text));
      } else {
        console.log(error);
        reject(BusinessUnitConfig);
      }
    });
  });
};

export const getConfig = async (filename = "") => {
  const blobService = createBlobServiceAnonymous(
    process.env.VUE_APP_HOST_NAME_AZURE_STORAGE || HOST_AZURE_STORAGE
  );
  return new Promise((resolve, reject) => {
    blobService.getBlobToText("config", filename, function(error, text) {
      if (!error) {
        resolve(JSON.parse(text));
      } else {
        console.log(error);
        reject({});
      }
    });
  });
};

export const getObjetiveConfig = async () => {
  const blobService = createBlobServiceAnonymous(
    process.env.VUE_APP_HOST_NAME_AZURE_STORAGE || HOST_AZURE_STORAGE
  );
  return new Promise((resolve, reject) => {
    blobService.getBlobToText("config", "objetive-config.json", function(
      error,
      text
    ) {
      if (!error) {
        resolve(JSON.parse(text));
      } else {
        console.log(error);
        reject(defaultObjetiveConfig);
      }
    });
  });
};

export default getBusinessConfig;
